(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      // Applied immediately (not lazily on first scroll) so position: sticky is
      // already active on load and there's no jump the first time the page scrolls.
      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.ticking = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.requestTick.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // Coalesces scroll events to at most one class-toggling pass per animation
    // frame, instead of running the logic on every scroll event fired.
    requestTick() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.onScroll();
        this.ticking = false;
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      if (!this.headerIsAlwaysSticky) {
        if (scrollTop > this.currentScrollTop && scrollTop > 200) {
          this.closeMenuDisclosure();
          this.closeSearchModal();
          this.header.classList.add('shopify-section-header-hidden');
        } else if (scrollTop < this.currentScrollTop) {
          if (this.preventReveal) {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrapp-editorial"] && !Shopify.designMode) return;
  try {
    
  if ('IntersectionObserver' in window) {
    const lazyVideos = document.querySelectorAll('video[data-lazy-autoplay]');
    const lazyVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px' }
    );
    lazyVideos.forEach((video) => lazyVideoObserver.observe(video));
  } else {
    document.querySelectorAll('video[data-lazy-autoplay]').forEach((video) => {
      video.autoplay = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrapp-video-editorial"] && !Shopify.designMode) return;
  try {
    
  if ('IntersectionObserver' in window) {
    const lazyVideos = document.querySelectorAll('.wrapp-video-editorial__video[data-lazy-autoplay]');
    const lazyVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px' }
    );
    lazyVideos.forEach((video) => lazyVideoObserver.observe(video));
  } else {
    document.querySelectorAll('.wrapp-video-editorial__video[data-lazy-autoplay]').forEach((video) => {
      video.autoplay = true;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
